import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'

import {start as styles} from '../styles'

class Start extends React.Component {

  render() {
    return <div/>
  }

  static propTypes = {
    isFetching: PropTypes.bool,
    error: PropTypes.string,
  }
}

export default withStyles(styles)(Start)



// WEBPACK FOOTER //
// ./src/sections/rent/components/start.js